<!-- <div class="w-full" id="PopularCities">
  <ng-container *ngIf="resetSwiper()">
    <swiper [config]="configSwiper">
        <ng-template swiperSlide  *ngFor="let cardData of dataSource?.Data?.Details">
          <iho-residence-unit [dataSource]="cardData"></iho-residence-unit>
        </ng-template>
      </swiper>
  </ng-container>
</div> -->

<div class="wrapper w-full mb-16">
  <div class="grid grid-cols-2 md:grid-cols-4 gap-4 h-[382px]">
    <div class="city_card col-span-1 rounded-xl relative" [ngClass]="city.span" *ngFor="let city of cities$">
      <a [href]="city.Url" target="_blank">
        <img [src]="'../../../../../assets/images/popular cities/' + city.PictureUrl " alt="" />
        <div class="city_desc absolute bottom-2 right-2 lg:bottom-5 lg:right-5">
          <div class="lg:text-lg font-bold text-white text-sm">{{city.Name}}</div>
          <div class="lg:text-md font-bold text-white text-xs bg-black-600 rounded-md text-center">{{city.Count}} واحد
            اقامتی</div>
        </div>
      </a>
    </div>
  </div>
</div>